module.exports = __webpack_public_path__ + "img/bg-proyectos-2.0704c08c.png";